import type { ReactNode } from "react";
import { createPortal } from "react-dom";

interface PortalProps {
  children: ReactNode;
  selectorQuery: string;
}

export const Portal = ({ children, selectorQuery }: PortalProps) => {
  if (typeof document === "undefined") {
    return null;
  }

  const container = document.querySelector(selectorQuery);

  if (!container) {
    return null;
  }

  return createPortal(children, container);
};
